import { motion } from "framer-motion";
import { HERO_IMAGE } from "../data/content";
import useSiteContent from "../hooks/useSiteContent";

export const Hero = () => {
  const cms = useSiteContent();
  const h = cms.hero || {};
  return (
    <section id="inicio" data-testid="hero-section" className="relative pt-20 bg-[#FAFAFA] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 items-center min-h-[calc(100vh-5rem)]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7 relative z-10 py-16 lg:py-0"
        >
          <p className="label-editorial text-clay mb-8">{h.kicker || "Clínica de Imagem · Leiria"}</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight">
            {h.title_before || "A sua imagem,"}
            <br />
            <span className="italic font-light text-clay">{h.title_highlight || "elevada"}</span>{" "}
            {h.title_after || "ao detalhe."}
          </h1>
          <p className="mt-8 max-w-md text-base md:text-lg text-black/60 font-light leading-relaxed">
            {h.subtitle || "Consultoria de imagem, hairstyling e visagismo com aconselhamento personalizado, para se sentir único todos os dias."}
          </p>
          <div className="mt-12 flex flex-wrap gap-4">
            <a
              href="#marcacoes"
              data-testid="hero-primary-cta"
              className="label-editorial bg-clay text-white px-8 py-4 hover:bg-clay-dark transition-colors duration-300"
            >
              {h.cta_primary || "Agendar Marcação"}
            </a>
            <a
              href="#servicos"
              data-testid="hero-secondary-cta"
              className="label-editorial border border-black/20 px-8 py-4 hover:border-clay hover:text-clay transition-colors duration-300"
            >
              {h.cta_secondary || "Conhecer Serviços"}
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="lg:col-span-5 relative lg:-ml-24 pb-16 lg:pb-0"
        >
          <div className="img-hover-zoom h-[50vh] lg:h-[80vh]">
            <img
              src={HERO_IMAGE}
              alt="Severina Gomes, consultora de imagem da INN.PACT em Leiria, com smartphone editorial"
              className="w-full h-full object-cover"
              fetchPriority="high"
              loading="eager"
              decoding="sync"
              width="960"
              height="1280"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
